import React from 'react'
import InvoiceContainer from '../../containers/admin_portal/invoices'

const InvoicePage = () => {
  return <InvoiceContainer/>
}

export default InvoicePage
